<slider *ngIf="isPlat"></slider>
<products></products>
<menus></menus>
<mobile></mobile>